export const createCheckoutAttemptId = () =>
  window.crypto?.randomUUID?.() || `checkout-${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const canSubmitPayment = ({ stripe, elements, paymentProcessing }) =>
  Boolean(stripe && elements && !paymentProcessing);
